import 'babel-polyfill';
import Game from './game';

new Game();
